export default __webpack_public_path__ + "static/media/auto_car.13091001.svg";